import { useEffect, useState } from 'react';
import { subscribeToast, type ToastItem } from '../utils/toast';
import { CheckCircle, XCircle, Info, AlertTriangle } from 'lucide-react';

export function Toast() {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  useEffect(() => {
    return subscribeToast(setToasts);
  }, []);

  if (!toasts.length) return null;

  const icons = {
    success: <CheckCircle size={16} />, error: <XCircle size={16} />,
    info: <Info size={16} />, warning: <AlertTriangle size={16} />,
  };

  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div key={t.id} className={`toast toast-${t.type}`}>
          {icons[t.type]} {t.message}
        </div>
      ))}
    </div>
  );
}
